import React, { Component } from "react";
import { ToggleControl } from '@wordpress/components';


class RedirectProduct extends Component {

    constructor(props) {
        super(props);
    }



    render() {

        const { attributes: {redirectProduct}, setAttributes } = this.props;

        const changeFunction = (value) => {
            setAttributes({
                redirectProduct: value
            });
        }

        return (
            <div className="components-base-control">
                <div className="components-base-control__field">
                    <label className="components-base-control__label">Redirect to Gumroad</label>
                    <ToggleControl
                        checked={ redirectProduct }
                        onChange={ changeFunction }
                    />
                </div>
            </div>
        );

    }
}


export default RedirectProduct;